export default __webpack_public_path__ + "static/network-ad45c14ee665d581b951752bd53c8714.png";